import * as Yup from "yup";

export const validationSchema = Yup.object({
  district_id: Yup.string().required("District is required!"),
  name: Yup.string().required(" Taluka name is required!"),
  is_active: Yup.string().required("Status is required!"),
});
